import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import bird from "../../../assets/images/Frame 145.png";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Line } from "react-chartjs-2";
import { Line as Rline } from "rc-progress";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);
const AreasInfo = ({ data }) => {
  const [months, setmonths] = useState([]);
  const month = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  useEffect(() => {
    var makeDate = new Date();
    const monthsArray = [];

    for (let i = 0; i < 7; i++) {
      monthsArray.push(month[makeDate.getMonth()]);
      makeDate.setMonth(makeDate.getMonth() - 1);
    }
    setmonths(monthsArray.reverse());
  }, []);

  const chartData = {
    labels: months,
    datasets: [
      {
        label: "recicling percentage",
        borderColor: "#009f3b",
        borderWidth: 2,
        data: [0, 0, 0, 0, 0, 0, data?.monthPct | 0],
      },
    ],
  };
  const options = {
    responsive: true,
    plugins: {
      legend: {
        display: false,
      },
      title: {
        display: false,
        text: "Area Chart Progress",
      },
      tooltips: {
        callbacks: {
          label: function (tooltipItem) {
            return tooltipItem.yLabel;
          },
        },
      },
    },
    scales: {
      y: {
        max: 100, // Set your maximum value here
        min: 0, // Set your minimum value here
      },
    },
    elements: {
      line: {
        borderColor: "rgba(0, 255, 0, 1)", // Green color
        borderWidth: 2,
      },
    },
  };

  const name = useParams().name?.split("-").join(" ");
  return (
    <div className="area-info-container">
      <div className="area-details">
        <div className="text-title">Stats</div>

        <div className="flex-stat">
          <div className="progress-line">
            <div className="left-progress">
              <div className="mb-3">
                <div className="d-flex fw-semibold align-items-center justify-content-between">
                  <div>Today</div>
                  <div>{data?.dayPct}%</div>
                </div>
                <Rline
                  gapDegree={200}
                  gapPosition="bottom"
                  trailWidth={3}
                  percent={data?.dayPct}
                  strokeWidth={3}
                  strokeColor="#009f3b"
                />
              </div>
              <div className="mb-3">
                <div className="d-flex fw-semibold align-items-center justify-content-between">
                  <div>This Month</div>
                  <div>{data?.monthPct}%</div>
                </div>
                <Rline
                  gapDegree={200}
                  gapPosition="bottom"
                  trailWidth={3}
                  percent={data?.monthPct}
                  strokeWidth={3}
                  strokeColor="#009f3b"
                />
              </div>
            </div>
          </div>

          <div className="progress-line">
            <div className="right-progress">
              <div className="mb-3">
                <div className="d-flex fw-semibold align-items-center justify-content-between">
                  <div>Last Day</div>
                  <div>0%</div>
                </div>
                <Rline
                  gapDegree={200}
                  gapPosition="bottom"
                  trailWidth={3}
                  percent={0}
                  strokeWidth={3}
                  strokeColor="#009f3b"
                />
              </div>

              <div className="mb-3">
                <div className="d-flex fw-semibold align-items-center justify-content-between">
                  <div>Last Month</div>
                  <div>0%</div>
                </div>
                <Rline
                  gapDegree={200}
                  gapPosition="bottom"
                  trailWidth={3}
                  percent={0}
                  strokeWidth={3}
                  strokeColor="#009f3b"
                />
              </div>
            </div>
          </div>
        </div>

        <div className="line-chart">
          <Line options={options} data={chartData} />
        </div>
      </div>
    </div>
  );
};

export default AreasInfo;
